import {autoserialize, autoserializeAs, inheritSerialization} from "cerialize";
import * as moment from "moment";
import { MomentTransformer } from "../helpers/moment-transformer";
import { ModelBase } from "./model-base";

@inheritSerialization(ModelBase)
export abstract class Tekstbericht {
  @autoserialize
  public abstract id: number;

  @autoserialize
  public abstract bericht: string;

  @autoserializeAs(MomentTransformer, 'tijd')
  public abstract tijd: moment.Moment;

}
